// Display helpers. Locale comes from the brand store (fr-FR / en-GB).

export function formatPrice(amount, currency, locale) {
  const number = Number(amount)
  if (!Number.isFinite(number)) return ''
  return `${number.toLocaleString(locale)} ${currency}`.trim()
}

// 237677123456 -> +237 677 123 456
export function formatMsisdnDisplay(msisdn, countryCode = '') {
  const digits = String(msisdn ?? '').replace(/\D/g, '')
  if (!digits) return ''
  const local = countryCode && digits.startsWith(countryCode) ? digits.slice(countryCode.length) : digits
  const grouped = local.replace(/(\d{3})(?=\d)/g, '$1 ').trim()
  return countryCode ? `+${countryCode} ${grouped}` : grouped
}

// The day the first charge lands, for the confirmation page ("free for 24 h, then ...").
export function formatChargeDate(trialDays, locale) {
  const date = new Date(Date.now() + Math.max(0, trialDays) * 24 * 60 * 60 * 1000)
  return date.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' })
}

export default { formatPrice, formatMsisdnDisplay, formatChargeDate }
